module.exports = "/assets/dist/images/lifetime-warranty-logo.png?847c5af438b913bd98d7323e7d93e4ca";